import React from 'react';

const Header = ({ imageData }) => {
    return (
        <header className="navbar navbar-sticky navbar-expand-lg navbar-dark">
            <div className="container position-relative">
                <a className="navbar-brand" href="/">
                    <img 
                        className="navbar-brand-regular" 
                        src={imageData} 
                        alt="brand-logo"
                        style={{ width: '106px', height: '31px' }} // Tam olarak belirttiğiniz boyut
                    />
                    <img 
                        className="navbar-brand-sticky" 
                        src="/img/logo-dark-2.svg" 
                        alt="sticky brand-logo"
                        style={{ width: '106px', height: '31px' }} // Tam olarak belirttiğiniz boyut
                    />
                </a>
            </div>
        </header>
    );
}

export default Header;